import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import ChecklistStatusDot from '../../reportCards/ChecklistStatusDot';

import type { DateComparison } from './types';

interface Props {
  bookByComparison: DateComparison;
  bundledBookBy?: string;
  bundledTravelTo?: string;
  hotelBookBy?: string;
  hotelTravelTo?: string;
  travelToComparison: DateComparison;
}

export default function ValidityComparisonChain({
  bookByComparison,
  bundledBookBy,
  bundledTravelTo,
  hotelBookBy,
  hotelTravelTo,
  travelToComparison,
}: Props) {
  return (
    <Stack direction="row" flexWrap="wrap" columnGap={4} rowGap={1.5}>
      {renderCluster(
        bookByComparison,
        renderDateRow('Hotel book by', hotelBookBy),
        renderDateRow('Experience book by', bundledBookBy),
      )}
      {renderCluster(
        travelToComparison,
        renderDateRow('Hotel travel to', hotelTravelTo),
        renderDateRow('Experience travel to', bundledTravelTo),
      )}
    </Stack>
  );
}

function renderCluster(comparison: DateComparison, top: React.ReactNode, bottom: React.ReactNode) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.25}
      sx={{ bgcolor: 'background.paper', border: 1, borderColor: 'divider', borderRadius: 1, px: 1.5, py: 1 }}
    >
      <ChecklistStatusDot hideLabel status={comparison.ok ? 'approved' : 'requires approval'} />
      <Stack spacing={0.75}>
        {top}
        {bottom}
      </Stack>
    </Stack>
  );
}

function renderDateRow(label: string, value?: string) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={600} sx={{ whiteSpace: 'nowrap' }}>
        {value ?? '—'}
      </Typography>
    </Box>
  );
}
